import {getUseQueryResultData} from "../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {LocationContext} from "../../model/location/location-context";

export const locationContextsSelector = () => createSelector(
  [getUseQueryResultData<LocationContext[]>],
  (data) => {
    return data ?? []
  }
);

export const locationContextSelector = () => createSelector(
  [getUseQueryResultData<LocationContext>],
  (data) => {
    return data
  }
);
